<div class="price-box">
  <div class="price-row">
    <span class="price-label">{{ 'COMPOSE.ROUTE.PRICE_LABEL' | translate }}</span>
    <div class="price-right">
      <span class="price-label">€ {{ secondClassPrice ? (secondClassPrice | priceFormat) : '0' }}</span>
      <span class="price-per-month">{{ 'COMPOSE.ROUTE.PRICE_PER_MONTH' | translate }}</span>
    </div>
  </div>
</div>
